import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-down-left', 'ArrowLongDownLeft', [["path",{"d":"M5 13v6h6m-6 0L19 5","key":"svg-0"}]]);